import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { ArtForBusinessService } from '../../services/art-for-business.service';
import { AppStateService } from '../../services/app-state.service';

@Component({
  selector: 'app-art-for-business',
  templateUrl: './art-for-business.component.html'
})
export class ArtForBusinessComponent implements OnInit, OnDestroy {
  form!: FormGroup;
  otpSent = false;
  otpCountdown = 0;
  private otpTimer: any;
  isSubmitting = false;

  // Banner slider
  bannerIndex = 0;
  private bannerTimer: any;
  slides = [
    { image: 'assets/images/wallpaper/B2B banner.jpg', mobile_image: 'assets/images/wallpaper/B2B Mobile.jpg', alt: 'Exclusive Wall Décor for Business' }
  ];

  // Our Clients slider
  clientIndex = 0;
  private clientTimer: any;
  clientSlides = [
    { image: 'assets/images/art-for-business/Web our clients 1.jpg', mobile_image: 'assets/images/art-for-business/Mobile view 1.jpg' },
    { image: 'assets/images/art-for-business/Web our clients 2.jpg', mobile_image: 'assets/images/art-for-business/Mobile view 2.jpg' },
    { image: 'assets/images/art-for-business/Web our clients 3.jpg', mobile_image: 'assets/images/art-for-business/Mobile view 3.jpg' }
  ];

  // How to Buy steps
  steps = [
    { image: 'assets/images/art-for-business/step-1.jpg', label: 'Call/Meet Our Creative Team' },
    { image: 'assets/images/art-for-business/step-2.jpg', label: 'Design Presentations & Selection' },
    { image: 'assets/images/art-for-business/step-3.jpg', label: 'Quotation Approval' },
    { image: 'assets/images/art-for-business/step-4.jpg', label: 'Product Manufacturing' },
    { image: 'assets/images/art-for-business/step-5.jpg', label: 'Door-Step Delivery' }
  ];

  // Why MahattaArt
  whyItems = [
    { icon: 'assets/images/art-for-business/why-mahattaart/icon1.jpg', label: 'Wall Decor Consultation' },
    { icon: 'assets/images/art-for-business/why-mahattaart/icon2.jpg', label: 'Personalized & Unique Concepts' },
    { icon: 'assets/images/art-for-business/why-mahattaart/icon3.jpg', label: 'Extensive Customization' },
    { icon: 'assets/images/art-for-business/why-mahattaart/icon4.jpg', label: 'End-To-End Service' },
    { icon: 'assets/images/art-for-business/why-mahattaart/icon5.jpg', label: 'Dedicated Account Manager' },
    { icon: 'assets/images/art-for-business/why-mahattaart/icon6.jpg', label: 'Top Quality' },
    { icon: 'assets/images/art-for-business/why-mahattaart/icon7.jpg', label: 'Licensed Artwork' },
    { icon: 'assets/images/art-for-business/why-mahattaart/icon8.jpg', label: 'Worldwide Shipping' }
  ];

  // Dropdown options
  designations = [
    'Owner', 'Director', 'CEO', 'GM/Manager', 'Architect', 'Interior Designer',
    'Procurement Head', 'Purchase Manager', 'Admin', 'Consultant', 'Other'
  ];

  areYouOptions = [
    { value: '1', label: 'Hotelier' },
    { value: '2', label: 'Interior Designer' },
    { value: '3', label: 'Other' }
  ];

  industries = [
    'Restaurant/Cafe', 'Corporate', 'Education', 'Hospital', 'Residential'
  ];

  areaOptions = [
    '0-500 sqft', '500-1000 sqft', '1000-2000 sqft', '2000-5000 sqft', '5000+ sqft'
  ];

  timeOptions = ['Immediately', '1 month', '3 months', '6 months'];
  sampleOptions = [{ value: '1', label: 'Yes' }, { value: '0', label: 'No' }];

  artWorkOptions = [
    'Abstract', 'Nature', 'Floral', 'Modern', 'Traditional', 'Scenic',
    'Geometric', 'Textured', 'Mandala', 'Kids', 'Typography', 'Minimalist',
    'Heritage', 'Custom'
  ];

  // Dynamic spaces based on selection
  spacesOptions: string[] = [];
  selectedSpaces: string[] = [];
  selectedArtWork: string[] = [];
  artWorkDropdownOpen = false;
  spacesDropdownOpen = false;

  private hotelierSpaces = ['Reception', 'Corridor', 'Lounge', 'Restaurant', 'Conference Room', 'Guest Room', 'Lobby', 'Spa', 'Pool Area', 'Bar'];
  private restaurantSpaces = ['Dining Area', 'Bar', 'Private Room', 'Entrance', 'Kitchen', 'Washroom'];
  private corporateSpaces = ['Reception', 'Conference Room', 'Cabin', 'Open Office', 'Cafeteria', 'Corridor'];
  private educationSpaces = ['Classroom', 'Library', 'Auditorium', 'Corridor', 'Office', 'Cafeteria'];
  private hospitalSpaces = ['Reception', 'Waiting Area', 'Ward', 'Corridor', 'Cabin', 'Cafeteria'];
  private residentialSpaces = ['Living Room', 'Bedroom', 'Kids Room', 'Dining Room', 'Study', 'Bathroom'];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private artService: ArtForBusinessService,
    private state: AppStateService
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      contact: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
      otp: ['', Validators.required],
      company: ['', Validators.required],
      designation: ['', Validators.required],
      city: [''],
      are_you: [''],
      industry: [''],
      area: [''],
      time: [''],
      request_sample_art: ['']
    });

    // Start banner auto-slide
    if (this.slides.length > 1) {
      this.bannerTimer = setInterval(() => {
        this.bannerIndex = (this.bannerIndex + 1) % this.slides.length;
      }, 5000);
    }

    // Start client auto-slide
    this.clientTimer = setInterval(() => {
      this.clientIndex = (this.clientIndex + 1) % this.clientSlides.length;
    }, 4000);
  }

  get canSendOtp(): boolean {
    return this.form.get('contact')?.valid === true && this.otpCountdown === 0;
  }

  sendOtp() {
    if (!this.canSendOtp) return;
    const contact = this.form.get('contact')?.value;
    this.authService.generateOtp({ mobile_no: contact, type: 'register' }).subscribe(
      () => {
        this.otpSent = true;
        this.state.showToast('OTP sent successfully!', 'success');
        this.otpCountdown = 30;
        this.otpTimer = setInterval(() => {
          this.otpCountdown--;
          if (this.otpCountdown <= 0) clearInterval(this.otpTimer);
        }, 1000);
      },
      (err: any) => {
        this.state.showToast(err?.error?.message || 'Failed to send OTP', 'info');
      }
    );
  }

  onAreYouChange() {
    const val = this.form.get('are_you')?.value;
    this.form.patchValue({ industry: '', area: '' });
    this.selectedSpaces = [];
    if (val === '1') {
      this.spacesOptions = this.hotelierSpaces;
    } else if (val === '2') {
      this.spacesOptions = this.residentialSpaces;
    } else {
      this.spacesOptions = [];
    }
  }

  onIndustryChange() {
    const industry = this.form.get('industry')?.value;
    this.selectedSpaces = [];
    switch (industry) {
      case 'Restaurant/Cafe': this.spacesOptions = this.restaurantSpaces; break;
      case 'Corporate': this.spacesOptions = this.corporateSpaces; break;
      case 'Education': this.spacesOptions = this.educationSpaces; break;
      case 'Hospital': this.spacesOptions = this.hospitalSpaces; break;
      case 'Residential': this.spacesOptions = this.residentialSpaces; break;
      default: this.spacesOptions = [];
    }
  }

  toggleSpace(space: string) {
    const idx = this.selectedSpaces.indexOf(space);
    idx > -1 ? this.selectedSpaces.splice(idx, 1) : this.selectedSpaces.push(space);
  }

  toggleArtWork(art: string) {
    const idx = this.selectedArtWork.indexOf(art);
    idx > -1 ? this.selectedArtWork.splice(idx, 1) : this.selectedArtWork.push(art);
  }

  submit() {
    if (this.form.invalid || this.isSubmitting) return;
    this.isSubmitting = true;

    const v = this.form.value;
    const payload = {
      name: v.name,
      email: v.email,
      contact: v.contact,
      otp: v.otp,
      company: v.company,
      designation: v.designation,
      city: v.city || '',
      are_you: v.are_you || '',
      industry: v.industry || '',
      area: v.area || '',
      spaces: this.selectedSpaces.join(','),
      art_work: this.selectedArtWork.join(','),
      time: v.time || '',
      request_sample_art: v.request_sample_art || ''
    };

    this.artService.add(payload).subscribe(
      () => {
        this.state.showToast('Record has been successfully added!', 'success');
        this.router.navigate(['/thank-you']);
        this.isSubmitting = false;
      },
      (err: any) => {
        this.state.showToast(err?.error?.message || 'Please enter valid OTP', 'info');
        this.isSubmitting = false;
      }
    );
  }

  // Client slider controls
  prevClient() { this.clientIndex = (this.clientIndex - 1 + this.clientSlides.length) % this.clientSlides.length; this.startClientTimer(); }
  nextClient() { this.clientIndex = (this.clientIndex + 1) % this.clientSlides.length; this.startClientTimer(); }
  goToClient(i: number) { this.clientIndex = i; this.startClientTimer(); }
  stopClientTimer() { if (this.clientTimer) { clearInterval(this.clientTimer); this.clientTimer = null; } }
  startClientTimer() {
    this.stopClientTimer();
    this.clientTimer = setInterval(() => { this.clientIndex = (this.clientIndex + 1) % this.clientSlides.length; }, 4000);
  }

  ngOnDestroy() {
    if (this.bannerTimer) clearInterval(this.bannerTimer);
    if (this.clientTimer) clearInterval(this.clientTimer);
    if (this.otpTimer) clearInterval(this.otpTimer);
  }
}
